import { Navigate, useLocation } from "react-router-dom";
import { Box } from "../components/Box";
import { Flex } from "../components/Flex";
import { SIDEBAR_WIDTH, TOPBAR_HEIGHT } from "../components/layoutConfig";
import Sidebar from "../components/Sidebar";
import { TopHeaderBar } from "../components/TopHeaderBar";
import { useAuth, UserVerificationStatus } from "../context/AuthContext";
import { ROUTE } from "../routes";
import { STORAGE_KEYS } from "../utils/constants";


const AuthenticatedRoute = ({ children, showMenu = true }: any) => {
  const { isLoggedIn, userVerificationStatus } = useAuth();
  const location = useLocation();

  const rawPath = (location.pathname + location.search).replace(/^\//, "");

  if (!isLoggedIn && !location.pathname.startsWith(ROUTE.LOGIN)) {
    if (!window.sessionStorage.getItem(STORAGE_KEYS.pendingReturnUrl)) {
      window.sessionStorage.setItem(STORAGE_KEYS.pendingReturnUrl, rawPath);
    }
  }

  const loginWithReturn = `${ROUTE.LOGIN}?returnurl=${encodeURIComponent(
    rawPath
  )}`;

  if (!isLoggedIn) {
    return <Navigate to={loginWithReturn} replace />;
  }

  if (
    userVerificationStatus === UserVerificationStatus.EmailVerificationRequired
  ) {
    return <Navigate to={ROUTE.VERIFY} replace />;
  }

  if (
    userVerificationStatus ===
    UserVerificationStatus.CompanyRegistrationRequired
  ) {
    return <Navigate to={ROUTE.ADD_COMPANY} replace />;
  }

  if (userVerificationStatus === UserVerificationStatus.BillingInfoRequired) {
    return <Navigate to={ROUTE.ADD_BILLING_INFORMATION} replace />;
  }

  if (
    userVerificationStatus === UserVerificationStatus.PrimaryPurposeRequired
  ) {
    return <Navigate to={ROUTE.ADD_PRIMARY_PURPOSE} replace />;
  }

  if (userVerificationStatus === UserVerificationStatus.DPORequired) {
    return <Navigate to={ROUTE.ADD_DPO} replace />;
  }

  if (userVerificationStatus === UserVerificationStatus.AccountPending) {
    return <Navigate to={ROUTE.ACCOUNT_PENDING} replace />;
  }

  return (
    isLoggedIn &&
    userVerificationStatus !== undefined && (
      <Flex>
        {showMenu && <TopHeaderBar />}
        {showMenu && <Sidebar />}
        <Box
          bg={showMenu ? "background" : "transparent"}
          ml={showMenu ? SIDEBAR_WIDTH : "0px"}
          mt={showMenu ? `${TOPBAR_HEIGHT}px` : "0px"}
          width={showMenu ? `calc(100% - ${SIDEBAR_WIDTH}px)` : "100%"}
          minHeight={
            showMenu ? `calc(100vh - ${TOPBAR_HEIGHT}px)` : "100vh"
          }
        >
          {children}
        </Box>
      </Flex>
    )
  );
};

export default AuthenticatedRoute;
